import { api, APIError, SuccessResponse } from '@/components/api-common';
import { User } from '@/reducers/product-management';

export type OrgPaymentSettings =
  | {
      support_ach: boolean;
      support_credit_card: boolean;
      enabled: true;
      charge_platform_fee: boolean;
      platform_fee_percent: string;
    }
  | { enabled: false };

export type OrgAlliance = {
  id: string;
  name: string;
  orgs: {
    id: string;
    name: string;
    payment: OrgPaymentSettings;
  }[];
};

export const fetchUser = async (): Promise<User> => {
  // Use raw api instance to avoid handleApiResponse which redirects on 115 errors
  // This is specifically for auth state checking where 115 is expected
  const url = 'user/service/userAuth/user/v2/';

  const data = await api.post(url, { json: {} }).json<SuccessResponse<User>>();

  if (data.result === 'success') {
    return data.data;
  } else {
    // Throw error with the API error structure for consistent handling
    throw new APIError({
      code: data.code,
      message: data.message,
      result: 'failed',
    });
  }
};
